import { createWorker } from "tesseract.js";

// SG plate formats (simple) e.g. "SBS1234A", "SK 1234 A"
const SG_PLATE_STRICT = /^[A-Z]{1,3}\d{1,4}[A-Z]$/;
const SG_PLATE_INNER = /[A-Z]{1,3}\d{1,4}[A-Z]/;

// Remove whitespace/symbols; keep only A-Z0-9 and join
function cleanForPlate(s) {
    return (s || "")
        .toUpperCase()
        .replace(/[—–-]/g, "")
        .replace(/[^A-Z0-9]/g, "");
}

// Find plate from full OCR text (no bbox)
function findPlateFromText(text) {
    if (!text) return null;

    const parts = text.split(/[\s\n]+/);

    for (let part of parts) {
        const cleaned = part.toUpperCase().replace(/[^A-Z0-9]/g, "");

        if (SG_PLATE_STRICT.test(cleaned)) {
            return cleaned;
        }
    }
    return null;
}

export default async function PlateNoDetectionHelper(imageData) {
    return new Promise((resolve, reject) => {
        if (imageData) {
            const img = new Image();
            img.src = imageData; // Set the base64 string as the image source
            img.onload = async () => {
                try {
                    const bitmap = await createImageBitmap(img); // Convert the image to a bitmap

                    // Start detecting the plate number immediately
                    const worker = await createWorker("eng", 1, {
                        logger: (m) => {
                            if (m.status) console.log(`${m.status} ${Math.round((m.progress || 0) * 100)}%`);
                        },
                    });

                    try {
                        await worker.setParameters({ preserve_interword_spaces: "1" });
                    } catch { }

                    const canvas = document.createElement("canvas");
                    canvas.width = bitmap.width;
                    canvas.height = bitmap.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(bitmap, 0, 0);

                    const { data } = await worker.recognize(canvas);
                    console.log("[OCR] full text:", data.text);

                    const plate = await findPlateFromText(data.text);
                    await worker.terminate();
                    resolve(plate);
                } catch (error) {
                    console.error("Failed to process imageData:", error);
                    reject(error);
                }
            };

            img.onerror = () => {
                console.error("Invalid base64 image data.");
                reject(new Error("Invalid base64 image data."));
            }
        }
    });
}